<template>
<div>
    <Breadcrumbs main="Sales"  title="Quotation Edit" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">

                            <div class="row">
                                <div class="col-sm-6">
                                    
                                    <div class="form-group">
                                        <label>Client <span><button class="btn-success ml-3" v-b-modal.modal-prevent-closing>Add New</button></span></label>
                                        <!-- <select class="form-control digits" v-model="quotation.client" @change="getClient">
                                            <option v-for="(client, index) in clients" :key="index" :value="client.user.id">{{ client.company_name }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="clients" label="company_name" :reduce="client => client.user.id" v-model="quotation.client" placeholder="Select a client"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <!-- <select class="form-control digits" v-model="quotation.project">
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="projects" label="title" :reduce="project => project.id" v-model="quotation.project" placeholder="Select a project"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" placeholder="Enter email address" v-model="quotation.email">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Currency</label>
                                        <select class="form-control digits" v-model="quotation.currency">
                                            <option v-for="(currency, index) in currencies" :key="index">{{ currency }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client Address</label>
                                        <input class="form-control" type="text" placeholder="Enter client address" v-model="quotation.client_address">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Billing Address</label>
                                        <input class="form-control" type="text" placeholder="Enter billing address" v-model="quotation.billing_address">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Quotation Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="quotation.quotation_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Due Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="quotation.due_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload Attachment</label>
                                        <b-form-file v-model="quotation.quotation_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable v-if="quotation.details" style="margin-bottom: 10px;" id="item-table" :tableData="quotation.details" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <!-- Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Total</label>
                                        <input class="form-control" type="number" placeholder="Enter total amount" disabled v-model="quotation.total" />
                                    </div>

                                    <!-- Vat -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Vat (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="quotation.vat_type">
                                                    <option disabled value="">Select VAT Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.vat_type">{{ errors.vat_type }}</small>
                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter vat (%)" v-model="quotation.vat" />
                                                <small class="text-danger" v-if="errors.vat">{{ errors.vat }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Vat Amount" v-model="vatAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Tax -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Tax (%)</label>
                                        <div class="d-flex flex-lg-nowrap flex-wrap w-100" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="quotation.tax_type">
                                                    <option disabled value="">Select Tax Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.tax_type">{{ errors.tax_type }}</small>
                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter tax (%)" v-model="quotation.tax" />
                                                <small class="text-danger" v-if="errors.tax">{{ errors.tax }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="taxAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Discount -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Discount (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <input class="form-control" type="number" placeholder="Enter discount (%)" v-model="quotation.discount" />
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="discountAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Grand Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total ({{ quotation.currency ? quotation.currency : "BDT" }})</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" disabled v-model="quotation.subtotal" />
                                    </div>

                                    <!-- In Words -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">In Words</label>
                                        <input class="form-control" type="text" placeholder="Enter grand total in words" v-model="quotation.in_words" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter remarks..." rows="2" v-model="quotation.remarks"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="mb-0 form-group">
                                        <button @click="validateType" class="btn btn-success mr-3" :disabled="isCreating">{{ isCreating ? 'Updating' : 'Update' }}</button>
                                        <router-link to="/sales/quotation/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>

    <!-- Container-fluid Ends-->

    <!-- Client Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add New Client" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <div class="form-group">
                <label>Name (Contact Person)</label>
                <input class="form-control" type="text" v-model="client.name">
            </div>

            <div class="form-group">
                <label>Company <span class="p-1 btn-success rounded ml-3" v-b-modal.modal-prevent-closing-company>Add New </span></label>
                <select class="form-control digits" v-model="client.company" @change="getCompany">
                    <option v-for="(company, index) in companies" :key="index" :value="company.id">{{ company.name }}</option>
                </select>
            </div>

            <div class="form-group">
                <label>Designation</label>
                <input class="form-control" type="text" v-model="client.designation">
            </div>

            <div class="form-group">
                <label>Phone Number</label>
                <input class="form-control" type="text" v-model="client.phone">
            </div>

            <div class="form-group">
                <label>Email</label>
                <input class="form-control" type="text" placeholder="Enter email address" v-model="client.email">
            </div>

            <div class="form-group">
                <label>Address</label>
                <input class="form-control" type="text" v-model="client.address">
            </div>
        </form>
    </b-modal>

    <b-modal id="modal-prevent-closing-company" ref="modal" title="Add Company" @show="resetCompanyModal" @hidden="resetClient" @ok="handleClientOk">
        <form ref="form" @submit.stop.prevent="handleClientSubmit">
            <b-form-group label="Company Name" label-for="name-input" invalid-feedback="Company Name is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.name" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="Email" label-for="name-input" invalid-feedback="Email address is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.email" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="Website" label-for="name-input">
                <b-form-input id="name-input" v-model="company.website"></b-form-input>
            </b-form-group>

            <b-form-group label="Address" label-for="name-input" invalid-feedback="Company address is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.address" :state="nameState" required></b-form-input>
            </b-form-group>

            <b-form-group label="BIN" label-for="name-input">
                <b-form-input id="name-input" v-model="company.bin"></b-form-input>
            </b-form-group>

            <b-form-group label="TIN" label-for="name-input">
                <b-form-input id="name-input" v-model="company.tin"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import ItemTable from "../items-table/edit-item-table.vue";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { toWords } from 'number-to-words'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        'v-select': vSelect
    },

    data() {
        return {
            discountAmount: computed(() => {
                if (this.quotation.total !== 0) {
                    const discount = this.quotation.discount || 0;
                    let total = this.quotation.total + discount * (this.quotation.total / 100)
                    let gtotal = total - this.quotation.total

                    return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                }
                return 0;
            }),
            basePrice: computed(() => {
                if (!this.quotation ?.total || !this.quotation ?.vat_type || !this.quotation ?.tax_type) return 0;

                const total = Number(this.quotation.total);
                const vat = Number(this.quotation.vat || 0);
                const tax = Number(this.quotation.tax || 0);

                if (this.quotation.vat_type === 'inclusive' && this.quotation.tax_type === 'inclusive') {
                    const divisor = 1 + (vat + tax) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.quotation.vat_type === 'inclusive') {
                    divisor += vat / 100;
                }
                if (this.quotation.tax_type === 'inclusive') {
                    divisor += tax / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

            taxAmount: computed(() => {
                if (this.quotation ?.tax && this.quotation ?.tax_type && this.quotation ?.total) {
                    const vat = Number(this.quotation.tax);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.quotation ?.vat && this.quotation ?.vat_type && this.quotation ?.total) {
                    const vat = Number(this.quotation.vat);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            quotation: {
                client: '',
                project: '',
                email: '',
                currency: '',
                client_address: '',
                billing_address: '',
                quotation_date: null,
                due_date: null,
                details: null,
                vat_type: '',
                tax_type: '',
                details_in_depth: [],
                total: computed(() => {
                    let total = 0;

                    if (this.quotation.details_in_depth.length >= 1) {
                        this.quotation.details_in_depth.map((item) => {
                            total = total + item.rate;
                        });
                    }
                    return total;
                }),
                vat: null,
                tax: null,
                vat_type: '',
                tax_type: '',
                discount: null,
                subtotal: computed(() => {
                    if (!this.quotation ?.total || !this.quotation ?.vat_type || !this.quotation ?.tax_type) return 0;

                    const total = Number(this.quotation.total);
                    const discount = Number(this.quotation.discount || 0);

                    // Case 1: both VAT and TAX are inclusive → just apply discount to total
                    if (this.quotation.vat_type === 'inclusive' && this.quotation.tax_type === 'inclusive') {
                        const discounted = total - (total * discount / 100);
                        return Math.round((discounted + Number.EPSILON) * 100) / 100;
                    }

                    // Case 2: Exclusive taxes → add them first
                    let calculated = total;

                    if (this.quotation.vat_type === 'exclusive') {
                        calculated += this.vatAmount;
                    }

                    if (this.quotation.tax_type === 'exclusive') {
                        calculated += this.taxAmount;
                    }

                    // Apply discount to final calculated total
                    const discounted = calculated - (calculated * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }),
                quotation_attachment: null,
                in_words: '',
                remarks: ''
            },
            nameState: null,
            client: {
                name: '',
                company: '',
                designation: '',
                phone: '',
                email: '',
                address: '',
                status: true
            },

            company: {
                name: '',
                email: '',
                website: '',
                address: '',
                bin: '',
                tin: ''
            },

            vat_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                vat_type: '',
                tax_type: '',
                vat: '',
                tax: '',
            },

            currencies: ['BDT', 'USD', 'EUR'],
            isCreating: false,
        };
    },

    computed: {
        ...mapState({
            detail: state => state.quotation.quotation_detail,
            items: state => state.item.items,
            projects: state => state.project.project,
            clients: state => state.client.client_without_pg,
            companies: state => state.client.company
        })
    },

    mounted() {
        this.$store.dispatch("quotation/fetchQuotationDetail", this.$route.params.id)
        this.$store.dispatch("item/fetchItem")
        this.$store.dispatch("project/fetchProject")
        this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("client/fetchCompany")
    },

    watch: {
        detail(oldValue, newValue) {
            this.quotation.client = this.detail?.client?.id || null
            this.quotation.project = this.detail?.project?.id || null
            this.quotation.email = this.detail?.email || null
            this.quotation.currency = this.detail?.currency || null
            this.quotation.client_address = this.detail?.client_address || null
            this.quotation.billing_address = this.detail?.billing_address || null
            this.quotation.quotation_date = this.detail?.quotation_date || null
            this.quotation.due_date = this.detail?.due_date || null
            this.quotation.quotation_attachment = this.detail?.quotation_attachment || null

            this.quotation.details = this.detail?.details
                ? JSON.parse(this.detail.details)
                : []

            this.quotation.details_in_depth = this.quotation.details

            this.quotation.total = this.detail?.total || 0
            this.quotation.vat = this.detail?.vat || 0
            this.quotation.tax = this.detail?.tax || 0
            this.quotation.vat_type = this.detail?.vat_type || null
            this.quotation.tax_type = this.detail?.tax_type || null
            this.quotation.discount = this.detail?.discount || 0
            this.quotation.subtotal = this.detail?.subtotal || 0
            this.quotation.in_words = this.detail?.in_words || null
            this.quotation.remarks = this.detail?.remarks || null
        },
        'quotation.subtotal'(val) {
            if (!val) {
                this.quotation.in_words = ''
                return
            }

            const text = toWords(val)
            this.quotation.in_words = text.replace(/\b\w/g, c => c.toUpperCase())
        }
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        getCompany() {
            this.$store.dispatch("client/fetchCompanyDetails", this.client.company).then(result => {
                this.client.address = result.data.address
            })
        },

        getClient() {
            this.$store.dispatch("client/fetchClientByUserId", this.quotation.client).then(result => {
                this.quotation.email = result.data.user.email
                this.quotation.client_address = result.data.company.address
                this.quotation.billing_address = result.data.company.address
            })
        },

        resetCompanyModal() {
            this.company.name = ''
            this.company.email = ''
            this.company.website = ''
            this.company.address = ''
            this.company.bin = ''
            this.company.tin = ''
            this.nameState = null
        },

        updateItems(data) {
            // console.log(data);
            if (data) {
                this.quotation.details = data;
                this.quotation.details_in_depth = data;
            }
        },

        uploadFile(e) {
            this.quotation.quotation_attachment = e.target.files[0];
        },
        validateType() {
            this.errors = {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            };

            let valid = true;

            if (!this.quotation.vat_type) {
                this.errors.vat_type = 'Vat type is required.';
                valid = false;
            }
            if (!this.quotation.tax_type) {
                this.errors.tax_type = 'Tax type is required.';
                valid = false;
            }
            if (!this.quotation.vat) {
                this.errors.vat = 'Vat is required.';
                valid = false;
            }
            if (!this.quotation.tax) {
                this.errors.tax = 'Tax is required.';
                valid = false;
            }

            if (valid) {
                this.onSubmit();
            }
        },

        onSubmit() {
            this.isCreating = true
            if (this.quotation.quotation_date !== null) {
                this.quotation.quotation_date = moment(String(this.quotation.quotation_date)).format("YYYY-MM-DD");
            }
            if (this.quotation.due_date !== null) {
                this.quotation.due_date = moment(String(this.quotation.due_date)).format("YYYY-MM-DD");
            }

            // this.quotation.details = JSON.stringify(this.quotation.details)

            // console.log(this.quotation.details)
            // alert(JSON.stringify(this.quotation.details))

            this.$store.dispatch("quotation/updateQuotation", {
                id: this.$route.params.id,
                quotation: this.quotation
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    setTimeout(() => {
                        this.$router.push('/sales/quotation/list')
                    }, 2000)

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.isCreating = false
        },

        resetModal() {
            this.client.first_name = ''
            this.client.company = '',
                this.client.designation = '',
                this.client.phone = '',
                this.client.email = '',
                this.client.address = ''
            this.nameState = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("client/addClient", this.client).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.quotation.client = response.data.user
                    this.quotation.email = response.data.email
                    this.quotation.client_address = response.data.address
                    this.quotation.billing_address = response.data.address

                    this.client.first_name = '',
                        this.client.company = null,
                        this.client.designation = '',
                        this.client.phone = '',
                        this.client.email = '',
                        this.client.address = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        handleClientOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleClientSubmit()
        },

        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },

        handleClientSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("client/addCompany", this.company).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.client.company = response.data.id
                    this.client.address = response.data.address

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-company')
            })
        }
    }
};
</script>
